import { createContext } from "react";
import { DataModel } from "./models/data.model";

interface AppContextType {
  model: DataModel;
  setModel: React.Dispatch<React.SetStateAction<DataModel>>;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  reset: () => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);
